import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Grid, Typography, Box } from '@material-ui/core';
import { BlueButton } from '../../components';
import { useTranslation } from 'react-i18next';

SearchSummary.propTypes = {};

function SearchSummary({ data, onClick }) {
  const { t } = useTranslation();
  const {
    departureAirportCode,
    destinationCountryCode,
    nationality,
    residentCountryCode,
    // documentType,
    // arrivalDate,
    transitAirports,
  } = data;

  let transitAirportsNew = [];
  if (transitAirports) {
    transitAirportsNew = transitAirports
      .map((airport) => airport.code)
      .join(', ');
  }

  return (
    <Card variant="outlined" elevation={0}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={6}>
            <Typography>
              Itinerary:{' '}
              <b>
                {departureAirportCode} to {destinationCountryCode}
              </b>
            </Typography>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={6}>
            <Typography>
              Arriving on: <b>{arrivalDate}</b>
            </Typography>
          </Grid> */}
          <Grid item xs={12} sm={6} md={6}>
            <Typography>
              Transit airports: <b>{transitAirportsNew || 'None'}</b>
            </Typography>
          </Grid>

          {/* <Grid item xs={12} sm={6} md={6}>
            <Typography>
              Passport type: <b>{documentType}</b>
            </Typography>
          </Grid> */}
          <Grid item xs={12} sm={6} md={6}>
            <Typography>
              Nationality: <b>{nationality}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography>
              Country of Residence: <b>{residentCountryCode}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={12}>
            <Box marginTop={1}>
              <BlueButton
                size="medium"
                variant="outlined"
                fullWidth={false}
                onClick={onClick}
              >
                {t('editDetails')}
              </BlueButton>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default SearchSummary;
